import styled from 'styled-components';
import ColorSF2 from '../../../styles/common/ColorSF2';

export const Main = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 15px;
`;
export const Title = styled.div`
  height: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: ${ColorSF2.paleBlue};
  font-weight: bold;
  width: auto;
  padding: 0 15px;
`;
export const CloseButtonImage = styled.img`
  width: 20px;
  height: 20px;
`;
